
import axiosInstance from "../Utils/axiosInterceptor";
import {User} from "../models/User";
import {OrderItem} from "../models/OrderItem";
import {MyLocation} from "../models/Location";


export class DriverService {

    static async addTopCart(data: OrderItem) {
        try {
            const response = await axiosInstance.post<OrderItem>("/add_to_cart/", data);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch restaurants:', error);
            throw error;
        }
    }

    static async placeOrder(data: OrderItem) {
        try {
            const response = await axiosInstance.post<OrderItem>("/place_order/", data);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch restaurants:', error);
            throw error;
        }
    }

    static async consumeOrder(userId: string) {
        try {
            const response = await axiosInstance.post("/consume_order/", { user_id: userId });
            return response.data;
        } catch (error) {
            console.error('Failed to consume order:', error);
            throw error;
        }
    }


    static async getAvailableDrivers(latitude:string, longitude:string) {
        try {
            const response = await axiosInstance.get<User[]>("/get_available_drivers/"+latitude+"/"+longitude);
            return response.data;
        } catch (error) {
            console.error('Failed to consume order:', error);
            throw error;
        }
    }

    static async getDriverLocation(driver_id:number){
        try {
            const response = await axiosInstance.get<MyLocation>("/get_driver_location/"+driver_id);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch restaurants:', error);
            throw error;
        }
    }
}